import * as React from 'react'

import { IDevelopmentDto } from 'api'
import API from 'api/clients'
import { plainToClass } from 'class-transformer'
import { QueryKey } from 'modules/module-api'
import useApi from 'modules/module-api/hooks/useApi/use-api'
import reporting from 'modules/module-reporting'
import { useAppDispatch } from 'modules/module-utils/hooks'

function useBuilding(buildingId: string | undefined) {
  const dispatch = useAppDispatch()

  const { data, isFetching, error, refetch } = useApi<IDevelopmentDto>(
    [QueryKey.BUILDING, buildingId],
    async () => {
      const response = await API({
        url: `/v3/developments/${buildingId}`,
      })
      return response.data
    },
    {
      enabled: false,
    },
  )

  React.useEffect(() => {
    !!buildingId &&
      refetch().catch((error) => {
        dispatch(reporting.actions.error(error))
      })
  }, [buildingId, dispatch, refetch])

  const building = React.useMemo(() => {
    return data ? plainToClass(IDevelopmentDto, data) : undefined
  }, [data])

  return { building, isFetching, error }
}

export default useBuilding
